import { formatPrice } from "utils/convertNumbThousand";

const Invoice = ({ invoice, carName }: { invoice: any; carName: any }) => {
  const couponRateText =
    invoice?.coupon_info?.coupon_type === "percentage"
      ? `${invoice?.coupon_info?.amount || "0"}% off`
      : ["fixed", "amount"].includes(invoice?.coupon_info?.coupon_type)
        ? `$${formatPrice(invoice?.coupon_info?.amount || "0")} off`
        : null;

  const couponDeductionValue = Number(
    invoice?.coupon_discount ?? invoice?.discount ?? 0,
  );

  const hasCouponDeduction =
    Boolean(invoice?.coupon_info?.name) && couponDeductionValue > 0;

  const hasRegularDiscount =
    !hasCouponDeduction &&
    invoice?.discount !== undefined &&
    Number(invoice?.discount || 0) > 0;

  return (
    <>
      <div className="mt-4">
        <div className="pb-4">
          <span className="text-lg font-semibold text-text-color">
            Trip Price
          </span>
        </div>
      </div>

      <div className="flex justify-between">
        <span className="truncate flex-1 text-text-color">{carName}</span>
        <span className="flex flex-col items-end ">
          <span className="text-xl font-medium text-text-color">
            ${formatPrice(invoice?.car_total)}
          </span>
          <span className="text-sm text-text-color">
            ${formatPrice(invoice?.avg_car_price_per_day) || "0.00"} x {invoice?.trip_days || 0}-Days
          </span>
        </span>
      </div>

      {invoice?.breakdown?.locations?.length > 0 &&
        invoice?.location_total !== undefined && (
          <div className="mt-4">
            <div className="pb-4">
              <span className="text-lg font-semibold text-text-color">
                Location Total
              </span>
            </div>
            {invoice?.breakdown?.locations?.map((location: any, index: any) => (
              <div key={index} className="flex justify-between ">
                <span className="truncate flex-1 text-text-color">
                  {location?.name}
                </span>
                <div className="flex flex-col items-end">
                  <span className="text-xl font-medium text-text-color">
                    ${formatPrice(location?.total)}
                  </span>
                  <span className="text-sm text-text-color">
                    ${formatPrice(location?.rate) || ""}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

      {invoice?.breakdown?.insurance?.length > 0 &&
        invoice?.insurance_total !== undefined && (
          <div className="mt-4">
            <div className="pb-4">
              <span className="text-lg font-semibold text-text-color">
                Insurance Total
              </span>
            </div>
            {invoice?.breakdown?.insurance?.map(
              (insurance: any, index: any) => (
                <div key={index} className="flex justify-between">
                  <span className="truncate flex-1 text-text-color">
                    {insurance?.name}
                  </span>
                  <div className="flex flex-col items-end">
                    <span className="text-xl font-medium text-text-color">
                      ${formatPrice(insurance?.total)}
                    </span>
                    <span className="text-sm text-text-color">
                      ${formatPrice(insurance?.rate) || ""}
                    </span>
                  </div>
                </div>
              ),
            )}
          </div>
        )}

      {invoice?.breakdown?.extras?.length > 0 &&
        invoice?.extras_total !== undefined && (
          <div className="mt-4">
            <div className="pb-4">
              <span className="text-lg font-semibold text-text-color">
                Trip Extras
              </span>
            </div>
            {invoice?.breakdown?.extras?.map((extra: any, index: any) => (
              <div key={index} className="flex justify-between ">
                <span className="truncate flex-1 text-text-color">
                  {extra?.name}
                </span>
                <div className="flex flex-col items-end">
                  <span className="text-xl font-medium text-text-color">
                    ${formatPrice(extra?.total)}
                  </span>
                  <span className="text-sm text-text-color">
                    ${formatPrice(extra?.rate) || "0.00"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

      {invoice?.booking_fee !== "0.00" &&
        invoice?.booking_fee !== undefined && (
          <div className="mt-4">
            <div className="pb-4">
              <span className="text-lg font-semibold text-text-color">
                Booking Fee
              </span>
            </div>
            {invoice?.breakdown?.booking_fee?.map(
              (bookingFee: any, index: any) => (
                <div key={index} className="flex justify-between ">
                  <span className="truncate flex-1 text-text-color">
                    {" "}
                    {bookingFee?.description
                      ? bookingFee?.description
                      : bookingFee?.name}
                  </span>
                  <div className="flex flex-col items-end">
                    <span className="text-xl font-medium text-text-color">
                      ${formatPrice(bookingFee?.total)}
                    </span>
                    <span className="text-text-color">
                      {bookingFee?.rate?.includes("%")
                        ? bookingFee?.rate
                        : `$${formatPrice(bookingFee?.rate) || "0.00"}`}
                    </span>
                  </div>
                </div>
              ),
            )}
          </div>
        )}

      {invoice?.breakdown?.taxes?.length > 0 && invoice?.tax !== undefined && (
        <div className="mt-4">
          <div className="pb-4">
            <span className="text-lg font-semibold text-text-color">Tax</span>
          </div>
          {invoice?.breakdown?.taxes?.map((taxes: any, index: any) => (
            <div key={index} className="flex justify-between ">
              <span className="text-text-color">
                {" "}
                {taxes?.description ? taxes?.description : taxes?.name}
              </span>
              <div className="flex flex-col items-end">
                <span className="text-xl font-medium text-text-color">
                  ${formatPrice(taxes?.total)}
                </span>
                <span className="text-text-color">
                  {taxes?.rate?.includes("%") ? taxes?.rate : `$${formatPrice(taxes?.rate) || "0.00"}`}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {invoice?.discount !== "0.00" && invoice?.discount !== undefined && (
        <div className="mt-4">
          <div className="flex justify-between ">
            <span className="text-lg font-normal text-text-color">
              Discount
            </span>
             <div className="flex flex-col items-end">
                <span className="text-xl font-medium text-text-color">
                 -${formatPrice(invoice?.discount)}
                </span>
                <span className="text-text-color">
                  {invoice?.breakdown?.discount?.rate?.includes("%") ? invoice?.breakdown?.discount?.rate : `$${formatPrice(invoice?.breakdown?.discount?.rate) || "0.00"}`}
                </span>
              </div>
          </div>
        </div>
      )}
      {invoice?.coupon_discount !== "0.00" && invoice?.coupon_discount !== null && (
        <div className="mt-4">
          <div className="flex justify-between ">
            <div>
              <span className="text-lg font-normal text-text-color">
                {invoice?.coupon_info?.name}
              </span>
              {couponRateText && (
                <p className="text-sm text-text-color">{couponRateText}</p>
              )}
            </div>
            <div className="text-right">
              <span className="text-xl font-medium text-text-color">
                -${formatPrice(couponDeductionValue)}
              </span>
            </div>
          </div>
        </div>
      )}
      {invoice?.coupon_discount !== "0.00" && invoice?.coupon_discount !== null && (
        <div className="mt-4">
          <div className="flex justify-between ">
            <div>
              <span className="text-lg font-normal text-text-color">
                {invoice?.coupon_info?.name}
              </span>
              {couponRateText && (
                <p className="text-sm text-text-color">{couponRateText}</p>
              )}
            </div>
            <div className="text-right">
              <span className="text-xl font-medium text-text-color">
                -${formatPrice(couponDeductionValue)}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="mt-8 border-t border-secondary-100  pt-4">
        {invoice.total_price_without_security !== "0.00" &&
          invoice.total_price_without_security !== undefined && (
            <div className="flex justify-between ">
              <div>
                <span className="text-lg font-semibold text-text-color">
                  Total Rental Price
                </span>
                <p className="mt-1 text-sm text-text-color">
                  Overall price rental
                </p>
              </div>
              <div>
                <span className="text-xl font-medium text-text-color">
                  ${invoice?.coupon_info ? `${formatPrice(invoice?.total_price_after_coupon_without_security)}` : `${formatPrice(invoice?.total_price_without_security)}`}
                </span>
              </div>
            </div>
          )}
      </div>

      {invoice.security_deposit_total !== "0.00" &&
        invoice.security_deposit_total !== undefined && (
          <div className="mt-4">
            <div className="flex justify-between ">
              <span className="text-lg font-semibold text-text-color">
                Refundable Deposit
              </span>
              <span className="text-xl font-medium text-text-color">
                ${formatPrice(invoice?.security_deposit_total)}
              </span>
            </div>
          </div>
        )}
    </>
  );
};

export default Invoice;
